<div
    *ngIf="entityInternal"
    class="agpr-targetingResults-cardWrapper agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-targetingResults-cardWrapper-focused': selectedContactId === entityInternal.id
    }"
>
    <div
        class="agpr-targetingResults-card-main"
        [ngClass]="{'agpr-targetingResults-card--excluded': excluded}"
        [attr.aria-labelledby]="id + '_entityName'"
        (agprClickUnless)="cardFocused()"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
    >
        <div
            class="agpr-targetingResults-card-thumbnail"
            [ngClass]="{'agpr-targetingResults-card-thumbnail--excluded': excluded}"
        >
            <img
                class="agpr-targetingResults-card-thumbnail-img"
                [agprImageSrc]="entityInternal?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                alt=""
                [agprDefaultImage]="imageDefault[entityInternal.entityType === entityTypes.CONTACT ? 'SMALL_CONTACT' : 'SMALL_OUTLET']"
                [ngClass]="{'excluded': excluded}"
            />
            <span
                *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                role="img"
                class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                [agprTooltip]="listMembershipTooltip"
                [escape]="false"
            ></span>
            <span
                *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                class="agpr-targetingResults-card-thumbnail-number"
                [agprTooltip]="listMembershipTooltip"
                [escape]="false"
            >
                {{ listMemberships.length }}
            </span>
        </div>
        <div
            class="agpr-targetingResults-card-description-container"
        >
            <div class="agpr-targetingResults-card-description"
                *ngIf="entityInternal.entityType === entityTypes.CONTACT"
            >
                <div
                    [id]="id + '_entityName'"
                    class="agpr-targetingResults-card-description-name"
                >
                    {{entityInternal.firstName}} {{entityInternal.lastName}}
                </div>
                <div
                    *ngIf="entityInternal.selectedEmployment?.jobTitle"
                    class="agpr-targetingResults-card-description-jobtitle"
                >{{entityInternal.selectedEmployment.jobTitle}}</div>
                <div
                    *ngIf="entityInternal.selectedEmployment?.outlet?.name"
                    class="agpr-targetingResults-card-description-outlet"
                >
                    <agpr-button
                        *ngIf="entityInternal.selectedEmployment?.outlet?.id"
                        [style]="buttonTypes.link"
                        class="agpr-targetingResults-card-description-outlet--leftAlign"
                        [label]="entityInternal.selectedEmployment.outlet.name"
                        (click)="focusOutlet()"
                    ></agpr-button>
                    <p *ngIf="!entityInternal.selectedEmployment?.outlet?.id"> {{ entityInternal.selectedEmployment.outlet.name }} </p>
                </div>
            </div>
            <div class="agpr-targetingResults-card-description"
                *ngIf="entityInternal.entityType === entityTypes.OUTLET"
            >
                <div
                    [id]="id + '_entityName'"
                    class="agpr-targetingResults-card-description-name"
                >
                    {{entityInternal.name}}
                </div>
                <div
                    *ngIf="entityInternal.mediaTypes && entityInternal.mediaTypes.length > 0"
                >
                    <span
                        *ngFor="let mediaType of entityInternal.mediaTypes; let last = last"
                    >
                        {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                    </span>
                </div>
                <div *ngIf="entityInternal.coverageFocus">{{entityInternal.coverageFocus.displayString}}</div>
            </div>
        </div>

        <div
            *ngIf="cardMode !== cardModes.editorMatchedContact"
            class="agpr-targetingResults-card-details-container"
        >
            <div class="agpr-targetingResults-card-details">
                <div
                    *ngIf="excluded"
                    class="agpr-targetingResults-card-details-excludedChip"
                >
                    {{ 'Excluded' | localize }}
                </div>
                <div class="agpr-targetingResults-card-details-primaryEmail-label">{{ 'Common.handleTypes.EMAIL' | localize }}</div>
                <div
                    class="agpr-targetingResults-card-details-primaryEmail"
                    [pTooltip]="entityInternal.entityType === entityTypes.CONTACT ? entityInternal.contactModel.primaryEmail : entityInternal.outletModel.primaryEmail"
                    tooltipPosition="top"
                >
                    {{entityInternal.entityType === entityTypes.CONTACT ? entityInternal.contactModel.primaryEmail : entityInternal.outletModel.primaryEmail}}
                </div>
            </div>
        </div>
    </div>
    <div class="agpr-contextMenu bottom right">
        <agpr-button
            [icon]="'fa-regular fa-duotone fa-user-plus'"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
            tooltip="Discover.targeting.actions.manageLists"
            (click)="openManageListDialog(entityInternal)"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="excluded"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
            [icon]="'fa-regular fa-duotone fa-square-plus'"
            tooltip="Discover.targeting.actions.includeRecipient"
            (click)="includeRecipient()"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="!excluded"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
            [icon]="'fa-regular fa-duotone fa-square-minus'"
            tooltip="Discover.targeting.actions.excludeRecipient"
            (click)="excludeRecipient()"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
    </div>
</div>
